<script lang="ts">
import { RouteName } from 'frontend/_setup/setupRouter/types/RouteName'
import { mapGetters } from 'vuex'

export default {
  name: 'NotSentCcmIndicator',
  data() {
    return {
      time: null,
      interval: null,
    }
  },
  setup() {
    const notSentLink = {
      name: RouteName.ClientCommunication,
      // params: {
      //   tabType: ClientCommunicationMessageTabType.Errors,
      // },
    }
    return { notSentLink }
  },
  computed: {
    ...mapGetters('notSentCCMCounter', ['counter']),
    ...mapGetters('currentContext', ['currentEvent']),
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  created() {
    this.$store.dispatch('notSentCCMCounter/fetch', { slug: this.currentEvent?.slug })
    this.time = new Date()
    this.interval = setInterval(() => {
      this.time = new Date()
    }, 1000)
  },
}
</script>
<template lang="pug">
router-link.header-indicator.d-flex.align-items-center.justify-content-center(
  v-if="counter || counter === 0"
  :to="notSentLink"
  v-tooltip.options="{ title: counter == 0 ? 'Great, there are no failed messages' : 'There are messages that were attempted to be sent but failed', placement: 'bottom' }"
)
  i.mi-outlined.mi-email
  .addon(v-if="counter") {{ counter > 99 ? '99+' : counter }}
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.header-indicator {
  color: map.get(themeVariables.$colors, onSurfaceVariant);
  z-index: 1;

  &:hover {
    color: map.get(themeVariables.$colors, onSurfaceVariant);
  }
}

.addon {
  font-size: 11px;
  position: absolute;
  top: -4px;
  bottom: auto;
  left: calc(100% - 12px);
  right: auto;
  border-radius: 2rem;
  text-align: center;
  min-width: 1rem;
  background: map.get(themeVariables.$colors, error);
  padding: 1px 4px;
  font-weight: 600;
  i {
    font-size: 0.7rem;
  }
}
</style>
